import { Form, Grid } from 'antd';
import { Modal } from 'components';
import { TermFormFields } from 'features/community/components/interface/type';
import { useCreateTermCancellation } from 'features/package/use-cases/create.cancellation';
import { LabelFormValues } from 'features/social-label/components/interface/type';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UserFormValues } from 'features/users/components/users-filter-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TermCancellationInfoFormItems } from './cancellation-info-form-items';

const { useBreakpoint } = Grid;
export const AddCancellationModal = ({ onClose }: { onClose: () => void }) => {
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<UserFormValues>();
  const { t } = useTranslation();
  const [isUpdating, setIsUpdating] = useState(false);
  const { isLoading, mutate } = useCreateTermCancellation();
  const getInitialValues = {
    [TermFormFields.content_english]: undefined,
    [TermFormFields.content_arabic]: undefined,
  };

  const handleUpdate = (formData: LabelFormValues) => {
    if (isUpdating) return; // If already updating, prevent further updates
    setIsUpdating(true); // Set updating state to true

    mutate(formData, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        className='right-modal cstmmdlright'
        title={'Cancellation-policy'}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={t('social.formfield.addnewlabel')}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
        }}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          initialValues={getInitialValues}
          onFinish={handleUpdate as any}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoading}
        >
          <TermCancellationInfoFormItems form={form as any} />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
